import React from 'react';
import { Link } from 'react-router-dom';
export default function CartPage() {
  return (
    <div style={{ minHeight:'100vh',paddingTop:80,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:16 }}>
      <h1 style={{ fontFamily:"'Playfair Display',serif",fontSize:'2rem',color:'var(--green-deep)' }}>CartPage</h1>
      <p style={{ color:'var(--text-light)' }}>Kjo faqe është duke u ndërtuar — implemento logjikën sipas nevojës.</p>
      <Link to="/" className="btn btn-primary">← Kthehu në Shtëpi</Link>
    </div>
  );
}
